import React from 'react'
import { connect } from 'react-redux'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { errorMessage } from 'lib/styleguide/base.scss'
import { experienceRoutesActions } from 'lib/api/experiences/routes'
import { compose } from 'redux'

export class DeleteExperienceRouteDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const { experienceRoute, onRequestClose, deleteExperienceRoute } = this.props

    this.setState({ deletePending: true })
    deleteExperienceRoute(experienceRoute.id)
      .then(() => { onRequestClose() })
      .catch(() => this.setState({ deletePending: false, deleteError: true }))
  }

  render () {
    const { route, onRequestClose } = this.props
    const { deletePending, deleteError } = this.state

    return (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        confirmText='Yes, remove this route.'
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        danger>
        <p>Are you sure you want to remove <strong>{route.name}</strong>?</p>
        {deleteError && <div className={errorMessage}>
          We encountered an error while removing this route. Please try again.
        </div>}
      </ConfirmationDialog>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteExperienceRoute: compose(dispatch, experienceRoutesActions.delete)
})

export const DeleteExperienceRouteDialogContainer = connect(
  null,
  mapDispatchToProps
)(DeleteExperienceRouteDialog)
